import { render, staticRenderFns } from "./EC06AO_COLLATERAL.vue?vue&type=template&id=3283c6ab&"
import script from "./EC06AO_COLLATERAL.vue?vue&type=script&lang=js&"
export * from "./EC06AO_COLLATERAL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports